/**
 * Reusable Change status confirmation modal
 */
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const StatusChangeConfirmationModal = ({
  open,
  cancel,
  title,
  item,
  loading,
  handleChangeStatus,
}) => {
  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="xs"
      open={open}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to change status of {item}?
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{ marginTop: "10px", marginBottom: "8px", marginRight: "8px" }}
      >
        <Button variant="contained" color="secondary" onClick={cancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleChangeStatus}
        >
          Yes
        </Button>
        {loading && <CircularProgress size={32} />}
      </DialogActions>
    </Dialog>
  );
};

export default StatusChangeConfirmationModal;